export default function PrivacyPolicy() {
  return <h1>PrivacyPolicy</h1>;
}
